import { PURCHASE_LIMIT_BEHAVIOR_TYPES } from 'src/apis/dto/DTOProduct';
import {
  getSubscriptionAction,
  getSubscriptionButtonTextKey,
  isDisabledAction,
} from 'src/components/AzarOnly/Subscription/utils';
import { useSubscriptionStatus } from 'src/hooks/useSubscription';

import type { SubscriptionProduct } from './SubscriptionCard';

interface SubscriptionButtonState {
  textKey: string;
  isDisabled: boolean;
  isHidden: boolean;
}

export const useSubscriptionButtonState = (
  product: SubscriptionProduct
): SubscriptionButtonState => {
  const { categoryId, purchaseLimitExceeded, purchaseLimitBehavior } = product;
  const subscriptionStatus = useSubscriptionStatus();

  const serverDisabled = !!(
    purchaseLimitExceeded && purchaseLimitBehavior === PURCHASE_LIMIT_BEHAVIOR_TYPES.DISABLED
  );
  const serverHidden = !!(
    purchaseLimitExceeded && purchaseLimitBehavior === PURCHASE_LIMIT_BEHAVIOR_TYPES.HIDDEN
  );

  const action = getSubscriptionAction({
    selectedPlan: categoryId,
    subscriptionStatus,
  });

  const textKey = getSubscriptionButtonTextKey(action, categoryId);
  const isDisabled = isDisabledAction(action) || serverDisabled;

  return { textKey, isDisabled, isHidden: serverHidden };
};
